export default __webpack_public_path__ + "static/media/Su.5bc23d92.jpg";